import  request  from '../../Interceptor/request.js'


//获取户号是否存在该项目下
export function getHouse(data) {
    return request({
        url: '/devInstance/list',
        method: 'get',
        params:data
    })
}

//发送验证码
export function sendCode(data) {
    return request({
        url: '/sms/send',
        method: 'get',
        params:data
    })
}

//获取验证码是否正确
export function codeYn(data) {
    return request({
        url: '/sms/check',
        method: 'get',
        params:data
    })
}

